const STRUCTURE_KEYS = ['id', 'legend', 'pathway', 'pathways', 'progress', 'recipients', 'email_subject', 'email_template', 'email_content', 'api_response', 'pathway_name', 'pathway_type', 'pathway_forks', 'pathway_title', 'pathway_content', 'pathway_nzbn_name', 'pathway_fieldsets', 'pathway_information', 'pathway_summary_fields', 'submission_heading'];
const TRACKING_KEYS = {
  CLIENT_ID: 'client_id',
  ID: 'id',
  BLOCK_ID: 'block_id',
  PATH: 'path',
  EVENT: 'event',
  TITLE: 'title',
  CHOICE: 'choice'
};
const EVENT_KEY = 'triage_form';
const EVENT_TYPES = {
  start: 'start',
  back: 'back',
  choice: 'choice',
  submit: 'submit'
};
export default class TriageFormPathwayController extends Classy {
  constructor() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let structure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super();

    // Make sure the data is an object
    if (typeof data !== 'object') throw new Error('Data must be an object');
    // Make sure the structure is an object
    if (typeof structure !== 'object') throw new Error('Structure must be an object');

    // The decision tree data
    this.data = data;
    // The progress of the decision tree
    this.progress = [this.data];

    // A unique client ID for tracking purposes
    this.clientID = this.getClientID();
    // The current pathway ID
    this.id = 1;
    // Whether or not the decision tree has started
    this.started = false;
    // An example data object for the tracking data
    this.trackingObject = this.getExampleTrackingData();

    // Create a structure object from the array of keys
    this.structure = STRUCTURE_KEYS.reduce((obj, key) => {
      // Set the key to the value in the passed in structure object or the key itself
      obj[key] = structure[key] || key;
      return obj;
    }, {});
  }
  getClientID() {
    let id = Math.floor(Date.now() + Math.random() * Date.now()) + Math.random().toString(36).substr(2, 9);
    let idArray = id.split('');
    for (let i = idArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [idArray[i], idArray[j]] = [idArray[j], idArray[i]];
    }
    return idArray.join('');
  }
  getEventTypes() {
    // Return an array of the event type values prefixed with 'decision_tree_'
    return Object.keys(EVENT_TYPES).map(key => `${EVENT_KEY}_${EVENT_TYPES[key]}`);
  }
  getExampleTrackingData() {
    return this.generateTrackingData({
      title: 'Example Title',
      choice: 'Example Choice',
      path: '/example/path'
    });
  }
  getCurrentProgress() {
    return {
      step: this.progress.length,
      data: this.progress[this.progress.length - 1]
    };
  }
  generateTrackingData() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      [TRACKING_KEYS.CLIENT_ID]: this.clientID,
      [TRACKING_KEYS.ID]: `${this.id}` || '1',
      [TRACKING_KEYS.BLOCK_ID]: this.data.blockID || 'TriageFormBlockID',
      [TRACKING_KEYS.PATH]: data.path || window.location.pathname,
      [TRACKING_KEYS.EVENT]: EVENT_KEY + '_' + `${data.event || EVENT_TYPES.start}`,
      [TRACKING_KEYS.TITLE]: data.title || null,
      [TRACKING_KEYS.CHOICE]: data.choice || null,
      ...data
    };
  }

  // Renders the current state of the decision tree
  render() {
    // Grab the structure in a more readable format
    const structure = this.structure;
    // Grab the last item in the progress array
    const data = this.progress[this.progress.length - 1];
    // Grab the options from the data
    const forks = data[structure.pathway_forks] || [];
    // Grab the response from the data
    const response = data[structure.api_response] || {};
    Object.keys(response).forEach(key => {
      const pathway = response[key];
      pathway.callback = () => {
        this.id = pathway[structure.id];
        if (this.progress.indexOf(pathway) === -1) {
          this.progress.push(pathway);
        }
        this.render();
      };
    });

    // if (data[structure.pathwayNZBN] && data[structure.pathwayNonNZBN]) {
    //   [data[structure.pathwayNZBN], data[structure.pathwayNonNZBN]].forEach((pathway) => {
    //     pathway.callback = () => {
    //       // Grab this branch's ID
    //       this.id = pathway[structure.id];

    //       // Track the user's choice
    //       this.track(EVENT_TYPES.choice, {
    //         [TRACKING_KEYS.TITLE]: pathway[structure.pathway_title],
    //         [TRACKING_KEYS.CHOICE]: pathway[structure.forkLabel],
    //       });

    //       // Add the selected option to the progress array
    //       // If this pathway isnt already in the progress array, add it
    //       this.progress.push(pathway);
    //       // Render the decision tree
    //       this.render();
    //     }
    //   })
    // }

    // If this is the first step, track the start event
    if (this.progress.length === 1 && this.started === false) this.track(EVENT_TYPES.start);
    this.started = true;
    this.callback('render', {
      step: this.progress.length,
      id: data[structure.id],
      pathway_type: data[structure.pathway_type],
      pathway_title: data[structure.pathway_title],
      pathway_content: data[structure.pathway_content],
      pathway_name: data[structure.pathway_name],
      pathway_nzbn_name: data[structure.pathway_nzbn_name],
      pathway_fieldsets: data[structure.pathway_fieldsets],
      legend: data[structure.legend],
      pathways: data[structure.pathways],
      progress: data[structure.progress],
      recipients: data[structure.recipients],
      email_subject: data[structure.email_subject],
      email_template: data[structure.email_template],
      email_content: data[structure.email_content],
      pathway_information: data[structure.pathway_information],
      pathway_summary_fields: data[structure.pathway_summary_fields] || [],
      api_response: response,
      submission_heading: data[structure.submission_heading],
      // Set up the options to include a callback function which will update the progress array and re-render the decision tree
      pathway_forks: forks.map(fork => ({
        ...fork,
        callback: () => {
          // Grab the value from the selected fork
          const pathway = fork[structure.pathway];

          // Make sure the branch value exists
          if (!pathway) throw new Error(`Branch key "${pathway}" does not exist.`);

          // Grab this branch's ID
          this.id = pathway[structure.id];

          // Track the user's choice
          this.track(EVENT_TYPES.choice, {
            [TRACKING_KEYS.TITLE]: data[structure.pathway_title],
            [TRACKING_KEYS.CHOICE]: fork.pathway.title
          });

          // Add the selected option to the progress array
          // If this pathway isnt already in the progress array, add it
          if (this.progress.indexOf(pathway) === -1) {
            this.progress.push(pathway);
          }
          // Render the decision tree
          this.render();
        }
      }))
    });
  }
  track(event) {
    let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!window.dataLayer) return;
    const trackingData = this.generateTrackingData({
      event: EVENT_KEY + '_' + `${event}`,
      ...data
    });
    window.dataLayer.push(trackingData);
  }

  // // Restarts the decision tree
  // restart() {
  //   // Track the restart event
  //   this.track(EVENT_TYPES.restart);
  //   // Reset the progress array
  //   this.progress = [this.data];
  //   // Render the decision tree
  //   this.render();

  //   // Callback
  //   this.callback('restart');
  // }

  get(key) {
    let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return data[key] || data[this.structure[key]] || null;
  }

  // Goes back one step in the decision tree
  back() {
    // Back sure the progress has more than one item
    if (this.progress.length <= 1) return this.restart();
    // Track the back event
    this.track(EVENT_TYPES.back);
    // Remove the last item from the progress array
    this.progress.pop();
    // Render the decision tree
    this.render();

    // Callback
    this.callback('back');
  }
  submit() {
    // Track the submit event
    this.track(EVENT_TYPES.submit, {
      [TRACKING_KEYS.TITLE]: this.progress[this.progress.length - 1][this.structure.questionTitle]
    });

    // Callback
    this.callback('submit');
  }
}